import { PlatformDetection } from './platform-detection';

export class BrowserDetection {
    private platformDetection: PlatformDetection;

    constructor(private userAgent: string) {
        this.platformDetection = new PlatformDetection(this.userAgent);
    }

    public isChromium(): boolean {
        const isChrome = /Chrom(e|ium)\/\d+\./.test(this.userAgent);
        const isMSEdge = /Edge\/\d+/.test(this.userAgent);
        const isMSEdgeChromium = /Edg\/\d+/.test(this.userAgent);
        const isMacOS = this.platformDetection.isMacOS();
        return isChrome && (isMacOS || (!isMSEdge && !isMSEdgeChromium));
    }

    public isFirefox(): boolean {
        return /Firefox/i.test(this.userAgent);
    }

    public isSafari(): boolean {
        return /Safari/i.test(this.userAgent) && !/Chrom(e|ium)\/\d+\./.test(this.userAgent);
    }

    public isOpera(): boolean {
        return /OPR/i.test(this.userAgent);
    }

    public isInternetExplorer(): boolean {
        return (
            !this.platformDetection.isMacOS() &&
            (/MSIE/i.test(this.userAgent) ||
                /Trident/i.test(this.userAgent) ||
                /Edg/i.test(this.userAgent))
        );
    }

    public isEdge(): boolean {
        return /Edg/i.test(this.userAgent);
    }

    public isEdgeChromium(): boolean {
        return /Edg\//i.test(this.userAgent);
    }

    public isInternetExplorerOrEdge(): boolean {
        return /MSIE|Trident/i.test(this.userAgent) || this.isEdge();
    }
}
